import * as React from 'react';
import { SVGProps } from 'react';

const OffersSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      fill="#A0A4A8"
      d='M6.652 9.586a2.934 2.934 0 0 1 2.934-2.934h1.333c.775 0 1.518-.307 2.067-.853l.934-.934a2.933 2.933 0 0 1 4.16 0l.934.934c.549.546 1.292.853 2.067.853h1.333a2.934 2.934 0 0 1 2.934 2.934v1.333c0 .775.307 1.518.853 2.067l.934.934a2.934 2.934 0 0 1 0 4.16l-.934.934a2.933 2.933 0 0 0-.853 2.067v1.333a2.934 2.934 0 0 1-2.934 2.934h-1.333c-.775 0-1.518.307-2.067.853l-.934.934a2.934 2.934 0 0 1-4.16 0l-.934-.934a2.933 2.933 0 0 0-2.067-.853H9.586a2.934 2.934 0 0 1-2.934-2.934v-1.333c0-.775-.307-1.518-.853-2.067l-.934-.934a2.933 2.933 0 0 1 0-4.16l.934-.934c.546-.549.853-1.292.853-2.067V9.586Z'
      opacity={0.2}
    />
    <path
      stroke="#A0A4A8"
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M6.652 9.586a2.934 2.934 0 0 1 2.934-2.934h1.333c.775 0 1.518-.307 2.067-.853l.934-.934a2.933 2.933 0 0 1 4.16 0l.934.934c.549.546 1.292.853 2.067.853h1.333a2.934 2.934 0 0 1 2.934 2.934v1.333c0 .775.307 1.518.853 2.067l.934.934a2.934 2.934 0 0 1 0 4.16l-.934.934a2.933 2.933 0 0 0-.853 2.067v1.333a2.934 2.934 0 0 1-2.934 2.934h-1.333c-.775 0-1.518.307-2.067.853l-.934.934a2.934 2.934 0 0 1-4.16 0l-.934-.934a2.933 2.933 0 0 0-2.067-.853H9.586a2.934 2.934 0 0 1-2.934-2.934v-1.333c0-.775-.307-1.518-.853-2.067l-.934-.934a2.933 2.933 0 0 1 0-4.16l.934-.934c.546-.549.853-1.292.853-2.067V9.586M12.5 19.5l7-7'
    />
    <path
      fill="#A0A4A8"
      d='M12.75 14a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM19.25 20.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z'
    />
  </svg>
);

export default OffersSidebar;
